import { gql } from '@apollo/client'

export const Query = gql`
  query RowItems($companyId: ID!, $filters: RowItemFilters, $order: RowItemOrder, $after: String, $before: String, $first: Int, $last: Int) {
    rowItems(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        priceCents
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
